var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5604_31723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6499 7.99844C1.6499 9.68256 2.31892 11.2977 3.50977 12.4886C4.70063 13.6794 6.31578 14.3484 7.9999 14.3484C9.68403 14.3484 11.2992 13.6794 12.49 12.4886C13.6809 11.2977 14.3499 9.68256 14.3499 7.99844C14.3499 6.31431 13.6809 4.69917 12.49 3.50831C11.2992 2.31745 9.68403 1.64844 7.9999 1.64844C6.31578 1.64844 4.70063 2.31745 3.50977 3.50831C2.31892 4.69917 1.6499 6.31431 1.6499 7.99844Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1499 6.39687C7.1499 5.92743 7.53046 5.54688 7.9999 5.54688C8.46934 5.54688 8.8499 5.92743 8.8499 6.39687C8.8499 6.68004 8.71218 6.931 8.49678 7.08667C8.25917 7.25839 7.96194 7.49098 7.72134 7.78294C7.4778 8.07847 7.2499 8.48682 7.2499 8.99687V9.19687C7.2499 9.61109 7.58569 9.94687 7.9999 9.94687C8.41412 9.94687 8.7499 9.61109 8.7499 9.19687V8.99687C8.7499 8.95464 8.76628 8.87358 8.87892 8.73688C8.99451 8.59662 9.16537 8.45419 9.37539 8.30242C9.96426 7.87684 10.3499 7.18187 10.3499 6.39687C10.3499 5.09901 9.29777 4.04688 7.9999 4.04688C6.70203 4.04688 5.6499 5.09901 5.6499 6.39687C5.6499 6.81109 5.98569 7.14687 6.3999 7.14687C6.81412 7.14687 7.1499 6.81109 7.1499 6.39687ZM7.9999 11.9969C8.44173 11.9969 8.7999 11.6387 8.7999 11.1969C8.7999 10.755 8.44173 10.3969 7.9999 10.3969C7.55807 10.3969 7.1999 10.755 7.1999 11.1969C7.1999 11.6387 7.55807 11.9969 7.9999 11.9969Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5604_31723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedQuestionMark);
export default __webpack_public_path__ + "static/media/ic-shared-question-mark.7eda8d1da37f4646b964155b0cfde58f.svg";
export { ForwardRef as ReactComponent };